//@ts-nocheck
import React from 'react'

const CustomToggle = React.forwardRef(({children, onClick}, ref) => (
  <button
    className='btn btn-icon btn-color-gray-400 justify-content-end'
    ref={ref}
    onClick={(e) => {
      e.preventDefault()
      onClick(e)
    }}
  >
    {children}
  </button>
))

export default CustomToggle
